module.exports = __webpack_public_path__ + "7ed9d40573f8865b51ded47bc2a850cb.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-1024.webp
// module id = 449
// module chunks = 0